const TermsAndConditions = () => {
  return (
    <div className="container mx-auto mt-[100px] md:mt-[200px] 2xl:mt-[250px] px-[50px] sm:px-[100px] xl:px-[250px] 2xl:px-[300px] pb-[50px]">
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold font-playfair text-center mb-[50px]">Terms and Conditions for Symphonys Artisanal Bakery</h1>
      <p className="text-[16px] font-medium font-montserrat mb-4">
        Welcome to Symphony’s Artisanal Bakery ("Symphony’s," "we," "our," or
        "us"). These Terms and Conditions ("Terms") govern your access to and
        use of our website www.thesymphonys.com (the "Website") and our products
        and services. By using our Website, you agree to these Terms. If you do
        not agree, please do not use the Website.
      </p>
      <h2 className="text-2xl font-playfair font-semibold mb-4">1. Use of the Website</h2>
      <ol className="list-decimal ml-10 mb-4 text-[16px] font-medium font-montserrat">
        <li>
          <strong>Eligibility:</strong> By using our Website, you represent that
          you are at least 18 years of age or have the consent of a parent or
          guardian.
        </li>
        <li>
          <strong>License:</strong> We grant you a limited, non-exclusive,
          non-transferable, and revocable license to use the Website for
          personal, non-commercial purposes.
        </li>
        <li>
          <strong>Prohibited Activities:</strong> You agree not to:
          <ul className="list-disc ml-10 mt-2">
            <li>Use the Website for any unlawful purpose.</li>
            <li>Violate any applicable laws or regulations.</li>
            <li>Interfere with the Website’s operation or security.</li>
            <li>Attempt to gain unauthorized access to our systems.</li>
            <li>
              Use bots, spiders, or other automated tools to interact with the
              Website.
            </li>
          </ul>
        </li>
      </ol>
      <h2 className="text-2xl font-playfair font-semibold mb-4">2. Orders and Purchases</h2>
      <ol className="list-decimal ml-10 mb-4 text-[16px] font-medium font-montserrat">
        <li>
          <strong>Product Availability:</strong> All products are subject to
          availability. We reserve the right to limit quantities or discontinue
          any product without prior notice.
        </li>
        <li>
          <strong>Pricing:</strong> Prices are displayed in Qatar Riyals and are
          subject to change without notice. Applicable taxes and shipping fees
          will be added at checkout.
        </li>
        <li>
          <strong>Payment:</strong> We accept cash and all major credit/debit
          cards. You agree to provide accurate and complete payment information.
          Your purchase is subject to our confirmation.
        </li>
        <li>
          <strong>Order Cancellation:</strong> We reserve the right to cancel
          any order for reasons including, but not limited to, product
          unavailability, errors in pricing or product descriptions, or
          suspected fraudulent activity.
        </li>
      </ol>
      <h2 className="text-2xl font-playfair font-semibold mb-4">3. Shipping</h2>
      <p className="mb-4 text-[16px] font-medium font-montserrat">
        Estimated delivery times are provided during checkout. Delivery times
        may vary based on your location and external factors.
      </p>
      <h2 className="text-2xl font-playfair font-semibold mb-4">4. Intellectual Property</h2>
      <ol className="list-decimal ml-10 mb-4 text-[16px] font-medium font-montserrat">
        <li>
          <strong>Ownership:</strong> All content on the Website, including
          text, graphics, logos, and images, is the property of Symphony’s
          Artisanal Bakery or its licensors and is protected by copyright,
          trademark, and other intellectual property laws.
        </li>
        <li>
          <strong>Restrictions:</strong> You may not reproduce, distribute,
          modify, or create derivative works from any content on the Website
          without our express written consent.
        </li>
      </ol>
      <h2 className="text-2xl font-playfair font-semibold mb-4">5. Limitation of Liability</h2>
      <ol className="list-decimal ml-10 mb-4 text-[16px] font-medium font-montserrat">
        <li>
          <strong>No Warranty:</strong> The Website is provided "as is" and "as
          available." We make no warranties, express or implied, regarding the
          Website’s operation, accuracy, or reliability.
        </li>
        <li>
          <strong>Limitation of Damages:</strong> To the maximum extent
          permitted by law, Symphony’s is not liable for any indirect,
          incidental, special, or consequential damages arising from your use of
          the Website or our products.
        </li>
      </ol>
      <h2 className="text-2xl font-playfair font-semibold mb-4">6. Indemnification</h2>
      <p className="mb-4 text-[16px] font-medium font-montserrat">
        You agree to indemnify and hold harmless Symphony’s, its affiliates, and
        their respective officers, directors, employees, and agents from any
        claims, damages, or expenses arising from your use of the Website or
        violation of these Terms.
      </p>
      <h2 className="text-2xl font-playfair font-semibold mb-4">7. Governing Law and Dispute Resolution</h2>
      <ol className="list-decimal ml-10 mb-4 text-[16px] font-medium font-montserrat">
        <li>
          <strong>Governing Law:</strong> These Terms are governed by the laws
          of Qatar, without regard to its conflict of law principles.
        </li>
        <li>
          <strong>Dispute Resolution:</strong> Any disputes will be resolved
          through binding arbitration in Qatar, except where prohibited by law.
        </li>
      </ol>
      <h2 className="text-2xl font-playfair font-semibold mb-4">8. Changes to the Terms</h2>
      <p className="mb-4 text-[16px] font-medium font-montserrat">
        We may update these Terms from time to time. Any changes will be
        effective immediately upon posting the revised Terms on the Website.
        Your continued use of the Website constitutes your acceptance of the
        updated Terms.
      </p>
      <h2 className="text-2xl font-playfair font-semibold mb-4">9. Contact Us</h2>
      <p className="mb-4 text-[16px] font-medium font-montserrat">
        If you have any questions or concerns about these Terms, please contact
        us:
      </p>
      <ul className="list-disc ml-10 mb-4 text-[16px] font-medium font-montserrat">
        <li>Email: info@thesymphonys.com</li>
        <li>Phone: +974 41487722</li>
        <li>Mail: P.O.Box 16157, City Center Mall, West Bay, Doha, Qatar</li>
      </ul>
    </div>
  );
};

export default TermsAndConditions;
